/**
 * Standard error codes
 */
export var ErrorCode;
(function (ErrorCode) {
    // Authentication
    ErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ErrorCode["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    ErrorCode["TOKEN_INVALID"] = "TOKEN_INVALID";
    ErrorCode["REFRESH_TOKEN_INVALID"] = "REFRESH_TOKEN_INVALID";
    ErrorCode["REFRESH_TOKEN_EXPIRED"] = "REFRESH_TOKEN_EXPIRED";
    ErrorCode["SESSION_REVOKED"] = "SESSION_REVOKED";
    ErrorCode["ACCOUNT_LOCKED"] = "ACCOUNT_LOCKED";
    ErrorCode["ACCOUNT_INACTIVE"] = "ACCOUNT_INACTIVE";
    ErrorCode["INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
    // Registration
    ErrorCode["EMAIL_ALREADY_EXISTS"] = "EMAIL_ALREADY_EXISTS";
    ErrorCode["REGISTRATION_PENDING"] = "REGISTRATION_PENDING";
    ErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    // Rate Limiting
    ErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    ErrorCode["AUTH_RATE_LIMIT_EXCEEDED"] = "AUTH_RATE_LIMIT_EXCEEDED";
    ErrorCode["PASSWORD_RESET_LIMIT_EXCEEDED"] = "PASSWORD_RESET_LIMIT_EXCEEDED";
    // Resources
    ErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    ErrorCode["ACCESS_REQUEST_NOT_FOUND"] = "ACCESS_REQUEST_NOT_FOUND";
    ErrorCode["SESSION_NOT_FOUND"] = "SESSION_NOT_FOUND";
    // Passkeys
    ErrorCode["PASSKEYS_DISABLED"] = "PASSKEYS_DISABLED";
    ErrorCode["PASSKEY_CHALLENGE_INVALID"] = "PASSKEY_CHALLENGE_INVALID";
    ErrorCode["PASSKEY_VERIFICATION_FAILED"] = "PASSKEY_VERIFICATION_FAILED";
    ErrorCode["PASSKEY_ALREADY_REGISTERED"] = "PASSKEY_ALREADY_REGISTERED";
    ErrorCode["PASSKEY_NOT_FOUND"] = "PASSKEY_NOT_FOUND";
    ErrorCode["PASSKEY_ENROLLMENT_TOKEN_INVALID"] = "PASSKEY_ENROLLMENT_TOKEN_INVALID";
    // Server
    ErrorCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ErrorCode["DATABASE_ERROR"] = "DATABASE_ERROR";
})(ErrorCode || (ErrorCode = {}));
